import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { hasAnyRole } from 'utils/credentials';
import { ROLES } from '../Users/roles';
import CampaignHome from './components/CampaignHome';

const Campaign = ({ match }) => {
  return hasAnyRole([ROLES.BCLC, ROLES.ADMIN, ROLES.SUPERADMIN]) ? (
    <div>
      <Route exact path={`${match.url}/`} component={CampaignHome} />
    </div>
  ) : (
    <Redirect to="/dashboard" />
  );
};

export default Campaign;
